// extracted by mini-css-extract-plugin
export default {"button":"wm-z","reviewSort":"xm-z"};